import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import { isEmpty } from 'lodash';

import config from '../../config';
import routeConfiguration from '../../routing/routeConfiguration';
import { pathByRouteName } from '../../util/routes';
import { apiBaseUrl } from '../../util/api';
import { generateCustomId } from '../../util/api';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import {isSchoolAdminRole, isTeacherRole, propTypes, TEACHER_ROLE} from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import {
  isSignupEmailTakenError,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import { showUser } from '../ProfilePage/ProfilePage.duck';
import {
  login,
  authenticationInProgress,
  signup,
  signupWithIdp,
  getContent,
} from '../../ducks/Auth.duck';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import ModalSignUp from '../../components/ModalSignUp/ModalSignUp';

import {
  Page,
  NamedLink,
  NamedRedirect,
  LinkTabNavHorizontal,
  ButtonTabNavHorizontal,
  IconEmailSent,
  InlineTextButton,
  SocialLoginButton,
  IconClose,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Modal,
  TermsOfService, ExternalLink, TermsModal, Button,
  IconCheckMarkAssets
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import ConfirmSignupForm from './ConfirmSignupForm/ConfirmSignupForm';
import LoginForm from './LoginForm/LoginForm';
import SignupForm from './SignupForm/SignupForm';
import { ContentText } from './ContentText';

import css from './AuthenticationPage.module.css';
import { FacebookLogo, GoogleLogo } from './socialLoginLogos';
import { parse } from '../../util/urlHelpers';

export class AuthenticationPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tosModalOpen: false,
      dtosModalOpen: false,
      isSignUpOpen: false,
      authError: Cookies.get('st-autherror')
        ? JSON.parse(Cookies.get('st-autherror').replace('j:', ''))
        : null,
      authInfo: Cookies.get('st-authinfo')
        ? JSON.parse(Cookies.get('st-authinfo').replace('j:', ''))
        : null,
      initialEmail: null,
      fromOfferPage: false,
    };

    this.handleSignUpOpen = this.handleSignUpOpen.bind(this);
    this.handleSignUpClose = this.handleSignUpClose.bind(this);
  }

  componentDidMount() {
    const { location, onShowUser, isAuthenticated, onGetContent, userRole } = this.props;
    // Remove the autherror cookie once the content is saved to state
    // because we don't want to show the error message e.g. after page refresh
    Cookies.remove('st-autherror');

    const urlParams = new URLSearchParams(location.search);
    const roleFromUrl = urlParams.get('role');
    const role = userRole || roleFromUrl;

    onGetContent(role);

    const referralId = parse(location.search)?.ref;
    const userId = referralId;
    const locationSearch = location.search;
    const withIdpFromOfferPage = locationSearch.substring(1) === 'from-offer-page'
    const fromOfferPage = location?.state?.fromOfferPage || withIdpFromOfferPage;

    this.setState({
      initialEmail: location?.state?.initialEmail,
      ...(fromOfferPage && { fromOfferPage }),
    })

    if(referralId) onShowUser(userId);
  }

  handleSignUpClose() { this.setState({ isSignUpOpen: false }) };
  handleSignUpOpen() { this.setState({ isSignUpOpen: true }) };

  render() {
    const {
      authInProgress,
      currentUser,
      intl,
      isAuthenticated,
      location,
      loginError,
      scrollingDisabled,
      signupError,
      submitLogin,
      submitSignup,
      confirmError,
      submitSingupWithIdp,
      tab,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      onResendVerificationEmail,
      onManageDisableScrolling,
      userShowError,
      stateOptions,
      userRoleOptions,
      areasCertifiedOptions,
      userRole,
      content,
    } = this.props;

    const referralId = parse(location.search)?.ref;
    const roleParams = parse(location.search)?.role;
    const role = userRole || roleParams;

    if (typeof window !== 'undefined' && referralId) window.sessionStorage.setItem('allCourseReferralId', referralId);

    const isConfirm = tab === 'confirm';
    const isLogin = tab === 'login';
    const isTeacherSignUp = role === TEACHER_ROLE.key;
    const locationFrom = location.state && location.state.from ? location.state.from : null;
    const authinfoFrom =
      this.state.authInfo && this.state.authInfo.from ? this.state.authInfo.from : null;
    const from = locationFrom ? locationFrom : authinfoFrom ? authinfoFrom : null;
    const fromListingPage = locationFrom && location?.state?.fromPage === 'ListingPage';

    const user = ensureCurrentUser(currentUser);
    const currentUserLoaded = !!user.id;

    const isAdmin = currentUserLoaded && isSchoolAdminRole(user);
    const isTeacher = currentUserLoaded && isTeacherRole(user);

    const authWithIdp = user?.attributes?.identityProviders?.length > 0;
    // We only want to show the email verification dialog in the signup
    // tab if the user isn't being redirected somewhere else
    // (i.e. `from` is present). We must also check the `emailVerified`
    // flag only when the current user is fully loaded.
    const showEmailVerification = !isLogin && currentUserLoaded && (!user.attributes.emailVerified || authWithIdp);

    // Already authenticated, redirect away from auth page
    if (isAuthenticated && from && !fromListingPage) {
      return <Redirect to={from} />;
    } else if (isAuthenticated && currentUserLoaded && !showEmailVerification) {
      return <NamedRedirect name="LandingPage" />;
    }

    const referralErrorMessage = (
      <div className={css.error}>
        <FormattedMessage id="AuthenticationPage.referralLinkFailed" />
      </div>
    );

    const loginErrorMessage = (
      <div className={css.error}>
        <FormattedMessage id="AuthenticationPage.loginFailed" />
      </div>
    );

    const signupErrorMessage = (
      <div className={css.error}>
        {isSignupEmailTakenError(signupError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    );

    const confirmErrorMessage = confirmError ? (
      <div className={css.error}>
        {isSignupEmailTakenError(confirmError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    ) : null;

    // eslint-disable-next-line no-confusing-arrow
    const errorMessage = (error, message) => (error ? message : null);
    const loginOrSignupError = isLogin
      ? errorMessage(loginError, loginErrorMessage)
      : errorMessage(signupError, signupErrorMessage);

    const fromState = { state: from ? { from } : { role } };

    const currentUserRole = location?.state?.role || role;
    const signupPageName = currentUserRole === "teacher" ? "SignupTeacherPage" : currentUserRole === "parent" ? "SignupParentPage" : "SignupSchoolAdminPage";
    const tabs = [
      {
        text: (
          <h2 className={css.tab}>
            <FormattedMessage id="AuthenticationPage.signupLinkText" />
          </h2>
        ),
        selected: !isLogin,
        linkProps: {
          name: signupPageName,
          to: fromState,
        },
        onClick: currentUserRole !== undefined ? false : this.handleSignUpOpen,
      },
      {
        text: (
          <h2 className={css.tab}>
            <FormattedMessage id="AuthenticationPage.loginLinkText" />
          </h2>
        ),
        selected: isLogin,
        linkProps: {
          name: 'LoginPage',
          to: fromState,
        },
      },
    ];

    const handleSubmitSignup = async values => {
      if (typeof window !== 'undefined') {
        window.lintrk('track', { conversion_id: 14493716 });
      }

      if(fromListingPage) {
        localStorage.setItem('fromState', JSON.stringify(fromState));
      }

      const { fname, lname, discountCode, subjects, usState, ...rest } = values;
      const { fromOfferPage } = this.state;
      const customId = await generateCustomId();

      const publicData = {
        userRole: role,
        ...(typeof discountCode === 'string' && discountCode.trim().length > 0 && {discountCode}),
        ...(discountCode === config.custom.discountCode && { discountStatus: true }),
        ...(fromOfferPage && {fromOfferPage}),
        customId,
        firstName: fname.trim(),
        lastName: lname.trim(),
      };

      const params = {
        firstName: fname.trim(),
        lastName: lname.trim(),
        ...publicData,
        ...rest,
      };

      !!referralId ? params.referralId = referralId : null;

      submitSignup(params);
    };

    const handleSubmitConfirm = async values => {
      if (typeof window !== 'undefined') {
        window.lintrk('track', { conversion_id: 14493716 });
      }

      if(fromListingPage) {
        localStorage.setItem('fromState', JSON.stringify(fromState));
      }

      const { idpToken, email, firstName, lastName, idpId } = this.state.authInfo;
      const { fromOfferPage } = this.state;
      const {
        email: newEmail,
        firstName: newFirstName,
        lastName: newLastName,
        discountCode,
        subjects,
        usState,
        ...rest
      } = values;

      const customId = await generateCustomId();

      // Pass email, fistName or lastName to Flex API only if user has edited them
      // sand they can't be fetched directly from idp provider (e.g. Facebook)

      const authParams = {
        ...(newEmail !== email && { email: newEmail }),
        ...(newFirstName !== firstName && { firstName: newFirstName }),
        ...(newLastName !== lastName && { lastName: newLastName }),
      };

      // If the confirm form has any additional values, pass them forward as user's protected data
      const protectedData = !isEmpty(rest) ? { ...rest } : null;
      const publicData = {
        firstName: newFirstName,
        lastName: newLastName,
        userRole: role,
        ...(typeof discountCode === 'string' && discountCode.trim().length > 0 && {discountCode}),
        ...(discountCode === config.custom.discountCode && { discountStatus: true }),
        ...(fromOfferPage && {fromOfferPage}),
        customId,
      };

      let refId = null;
      if (TEACHER_ROLE.key === role) publicData.searchParams = [newFirstName, newLastName];
      if (typeof window !== 'undefined') refId = window.sessionStorage.getItem('allCourseReferralId');
      const privateData = !!refId ? { referral: { id: refId, reward: false, sum: 0 }, isReferral: true } : {};

      if (!!refId) publicData.onboardingProcess = { referral: refId }

      submitSingupWithIdp({
        idpToken,
        idpId,
        firstName: newFirstName,
        lastName: newLastName,
        publicData,
        privateData,
        ...authParams,
        ...(!!protectedData && { protectedData }),
      });
    };

    const getDefaultRoutes = () => {
      const routes = routeConfiguration();
      const baseUrl = apiBaseUrl();

      // Route where the user should be returned after authentication
      // This is used e.g. with EditListingPage and ListingPage
      const fromOfferPage = this.state.fromOfferPage;
      const fromParam = from ? `from=${from}` : '';


      // Default route where user is returned after successfull authentication
      const defaultReturn = pathByRouteName('SignupPage', routes);
      const defaultReturnParam = defaultReturn && fromOfferPage ? `&defaultReturn=${defaultReturn}?from-offer-page&role=${role}` : defaultReturn && !fromOfferPage ? `&defaultReturn=${defaultReturn}?role=${role}` : '';

      // Route for confirming user data before creating a new user
      const defaultConfirm = pathByRouteName('ConfirmPage', routes);
      const defaultConfirmParam = defaultConfirm && fromOfferPage ? `&defaultConfirm=${defaultConfirm}?from-offer-page&role=${role}` : defaultConfirm && !fromOfferPage ? `&defaultConfirm=${defaultConfirm}?role=${role}` : '';

      return { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam };
    };
    const authWithFacebook = () => {
      const defaultRoutes = getDefaultRoutes();
      const { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam } = defaultRoutes;

      window.location.href = `${baseUrl}/api/auth/facebook?${fromParam}${defaultReturnParam}${defaultConfirmParam}`;
    };

    const authWithGoogle = () => {
      const defaultRoutes = getDefaultRoutes();
      const { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam } = defaultRoutes;
      window.location.href = `${baseUrl}/api/auth/google?${fromParam}${defaultReturnParam}${defaultConfirmParam}`;
    };

    const idp = this.state.authInfo
      ? this.state.authInfo.idpId.replace(/^./, str => str.toUpperCase())
      : null;

    // Form for confirming information frm IdP (e.g. Facebook)
    // before new user is created to Flex
    const confirmForm = (
      <div className={css.content}>
        {/* {contentText} */}
        {content && <ContentText role={role} content={content} />}
        <div className={css.contentForm}>
          <h1 className={css.contentFormTitle}>
            {isTeacherSignUp ? (
              <FormattedMessage id="AuthenticationPage.createYourFreeProfile" />
            ) : (
              <FormattedMessage id="AuthenticationPage.createYourFreeAccount" />
            )}
          </h1>
          <h2 className={css.signupWithIdpTitle}>
            <FormattedMessage id="AuthenticationPage.confirmSignupWithIdpTitle" values={{ idp }} />
          </h2>
          <p className={css.confirmInfoText}>
            <FormattedMessage id="AuthenticationPage.confirmSignupInfoText" />
          </p>
          {confirmErrorMessage}
          <ConfirmSignupForm
            className={css.form}
            initialValues={{role}}
            onSubmit={handleSubmitConfirm}
            inProgress={authInProgress}
            onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
            authInfo={this.state.authInfo}
            idp={idp}
            fromOfferPage={this.state.fromOfferPage}
            stateOptions={stateOptions}
            userRoleOptions={userRoleOptions}
            areasCertifiedOptions={areasCertifiedOptions}
            isTeacherSignUp={isTeacherSignUp}
            role={role}
          />
        </div>
      </div>
    );

    // Social login buttons
    const showFacebookLogin = !!process.env.REACT_APP_FACEBOOK_APP_ID;
    const showGoogleLogin = !!process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const showSocialLogins = showFacebookLogin || showGoogleLogin;

    const facebookButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithFacebook" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithFacebook" />
    );

    const googleButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithGoogle" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithGoogle" />
    );
    const socialLoginButtonsMaybe = showSocialLogins ? (
      <div className={css.idpButtons}>
        <div className={css.socialButtonsOr}>
          <span className={css.socialButtonsOrText}>
            <FormattedMessage id="AuthenticationPage.or" />
          </span>
        </div>

        {showFacebookLogin ? (
          <div className={css.socialButtonWrapper}>
            <SocialLoginButton onClick={() => authWithFacebook()}>
              <span className={css.buttonIcon}>{FacebookLogo}</span>
              {facebookButtonText}
            </SocialLoginButton>
          </div>
        ) : null}

        {showGoogleLogin ? (
          <div className={css.socialButtonWrapper}>
            <SocialLoginButton onClick={() => authWithGoogle()}>
              <span className={css.buttonIcon}>{GoogleLogo}</span>
              {googleButtonText}
            </SocialLoginButton>
          </div>
        ) : null}
      </div>
    ) : null;

    const selectedUserRole = !!location && location?.userRole

    // Tabs for SignupForm and LoginForm
    const authenticationForms = (
      <div className={classNames(css.content, {[css.contentLogin]:isLogin})}>
        {/* {!isLogin && contentText} */}
        {!isLogin && content && <ContentText role={role} content={content} />}
        <div className={css.contentForm}>
          {!isLogin && (
            <h1 className={css.contentFormTitle}>
              {isTeacherSignUp ? (
                <FormattedMessage id="AuthenticationPage.createYourFreeProfile" />
              ) : (
                <FormattedMessage id="AuthenticationPage.createYourFreeAccount" />
              )}
            </h1>
          )}
          <ButtonTabNavHorizontal className={css.tabs} tabs={tabs} />

          {loginOrSignupError}
          {userShowError && <p className={css.error}>{referralErrorMessage}</p>}

          {isLogin ? (
            <LoginForm className={css.loginForm} onSubmit={submitLogin} inProgress={authInProgress} />
          ) : (
            <SignupForm
              initialEmail={this.state.initialEmail}
              initialValues={{role}}
              className={css.signupForm}
              onSubmit={handleSubmitSignup}
              inProgress={authInProgress}
              selectedUserRole={selectedUserRole}
              onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
              fromOfferPage={this.state.fromOfferPage}
              stateOptions={stateOptions}
              userRoleOptions={userRoleOptions}
              areasCertifiedOptions={areasCertifiedOptions}
              isTeacherSignUp={isTeacherSignUp}
              role={role}
            />
          )}

          {socialLoginButtonsMaybe}
        </div>
      </div>
    );

    const formContent = isConfirm ? confirmForm : authenticationForms;

    const name = user.attributes.profile.firstName;
    const email = <span className={css.email}>{user.attributes.email}</span>;

    const resendEmailLink = (
      <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
        <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
      </InlineTextButton>
    );
    const fixEmailLink = (
      <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
        <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
      </NamedLink>
    );

    const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
      sendVerificationEmailError
    )
      ? 'AuthenticationPage.resendFailedTooManyRequests'
      : 'AuthenticationPage.resendFailed';
    const resendErrorMessage = sendVerificationEmailError ? (
      <p className={css.error}>
        <FormattedMessage id={resendErrorTranslationId} />
      </p>
    ) : null;

    const emailVerificationContent = isConfirm || authWithIdp ? (
      <div className={css.contentColumn}>
        {!isTeacher &&
          <NamedLink
            className={css.verifyClose}
            name="ProfileSettingsPage"
            to={{ state: { fromOfferPage: this.state.fromOfferPage } }}
          >
            <span className={css.closeText}>
              <FormattedMessage id="AuthenticationPage.verifyEmailClose" />
            </span>
            <IconClose rootClassName={css.closeIcon} />
          </NamedLink>
        }
        <IconEmailSent className={css.modalIcon} />
        <h1 className={css.modalTitle}>
          Thanks for signing up for
          <span className={css.red}> All</span>
          <span className={css.blue}>Course</span>!
        </h1>
        <p className={css.modalMessage}>
          You’re ready to start finding great teachers and courses.
        </p>
        {isTeacher &&
          <NamedLink
            className={css.modalButton}
            name="ProfileSettingsPage"
            to={{ state: { fromOfferPage: this.state.fromOfferPage } }}
          >
            <FormattedMessage id="AuthenticationPage.verifyEmailCloseForTeacher" />
          </NamedLink>
        }
        {isAdmin && this.state.fromOfferPage && <p className={css.modalMessage}>
          Would you like to chat with us?
          Schedule a call with a member of our team &nbsp;
          <ExternalLink
            href="https://meetings.hubspot.com/rachel-post/business-cards-scheduling-link"
            className={css.underline}>here</ExternalLink>.
        </p>}

        </div>
      ) : (
      <div className={css.contentColumn}>
        {!isTeacher && <NamedLink className={css.verifyClose} name="ProfileSettingsPage">
          <span className={css.closeText}>
            <FormattedMessage id="AuthenticationPage.verifyEmailClose"/>
          </span>
          <IconClose rootClassName={css.closeIcon}/>
        </NamedLink>}
        <IconEmailSent className={css.modalIcon} />
        <h1 className={css.modalTitle}>
          <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
        </h1>
        <p className={css.modalMessage}>
          <FormattedMessage id="AuthenticationPage.verifyEmailText" values={{ email }} />
        </p>

        {isTeacher && <NamedLink className={css.modalButton} name="ProfileSettingsPage">
          <FormattedMessage id="AuthenticationPage.verifyEmailCloseForTeacher"/>
          </NamedLink>
        }

        {isAdmin && this.state.fromOfferPage && <p className={css.modalMessageChart}>
          <FormattedMessage
            id="AuthenticationPage.verifyEmailChart"
            values={{
              hereText: <ExternalLink
                href="https://meetings.hubspot.com/rachel-post/business-cards-scheduling-link"
                className={css.underline}>
                here
              </ExternalLink>,
            }}
          />
        </p>}
        {resendErrorMessage}

        <div className={css.bottomWrapper}>
          <p className={css.modalHelperText}>
            {sendVerificationEmailInProgress ? (
              <FormattedMessage id="AuthenticationPage.sendingEmail" />
            ) : (
              <FormattedMessage id="AuthenticationPage.resendEmail" values={{ resendEmailLink }} />
            )}
          </p>
          <p className={css.modalHelperText}>
            <FormattedMessage id="AuthenticationPage.fixEmail" values={{ fixEmailLink }} />
          </p>
        </div>
      </div>
    );

    const roleClass = role === "teacher" ? css.teacher : role === "parent" ? css.parent : css.admin

    const siteTitle = config.siteTitle;
    const schemaTitle = isLogin
      ? intl.formatMessage({ id: 'AuthenticationPage.schemaTitleLogin' }, { siteTitle })
      : intl.formatMessage({ id: 'AuthenticationPage.schemaTitleSignup' }, { siteTitle });

    const topbarClasses = classNames({
      [css.hideOnMobile]: showEmailVerification,
    });

    const successPageParams = {
      isConfirm: isConfirm,
      authWithIdp: authWithIdp,
      fromOfferPage: this.state.fromOfferPage,
      isTeacher: isTeacher,
      isAdmin: isAdmin,
      user: user,
      sendVerificationEmailInProgress: sendVerificationEmailInProgress,
      sendVerificationEmailError: sendVerificationEmailError
    }

    const ogImage = content?.metaImage && `https:${content?.metaImage?.fields?.file?.url}`;

    return (
      <Page
        title={content?.metaTitle || schemaTitle}
        description={content?.metaDescription}
        scrollingDisabled={scrollingDisabled}
        referrer="strict-origin-when-cross-origin"
        schema={{
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: schemaTitle,
        }}
        facebookImages={ogImage && [{
          image: ogImage,
          url: `${ogImage}`,
          width: 600,
          height: 314,
        }]}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer className={topbarClasses} />
          </LayoutWrapperTopbar>
          <LayoutWrapperMain className={css.layoutWrapperMain}>
            <div className={classNames(css.root, roleClass)}>
              {showEmailVerification ?
                (<NamedRedirect state={successPageParams} name="SuccessSignUpPage"  />) :
                formContent}
            </div>
            <Modal
              id="AuthenticationPage.tos"
              isOpen={this.state.tosModalOpen}
              onClose={() => this.setState({ tosModalOpen: false })}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.termsWrapper}>
                <h2 className={css.termsHeading}>
                  <FormattedMessage id="AuthenticationPage.termsHeading" />
                </h2>
                <TermsOfService />
              </div>
            </Modal>
            <Modal
              id="TopbarSignUpAuth"
              isOpen={this.state.isSignUpOpen}
              onClose={this.handleSignUpClose}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
              closeButtonMessage={" "}
            >
              <ModalSignUp onClose={this.handleSignUpClose} location={location} routes={routeConfiguration()} />
            </Modal>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
            <Footer  currentPage="AuthenticationPage"/>
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

AuthenticationPageComponent.defaultProps = {
  currentUser: null,
  loginError: null,
  signupError: null,
  confirmError: null,
  tab: 'signup',
  sendVerificationEmailError: null,
  showSocialLoginsForTests: false,
  stateOptions: config.custom.stateOptions,
  userRoleOptions: config.custom.userRoleOptions,
  areasCertifiedOptions: config.custom.areasCertifiedOptions,
};

const { bool, func, object, oneOf, shape } = PropTypes;

AuthenticationPageComponent.propTypes = {
  authInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  isAuthenticated: bool.isRequired,
  loginError: propTypes.error,
  scrollingDisabled: bool.isRequired,
  signupError: propTypes.error,
  confirmError: propTypes.error,

  submitLogin: func.isRequired,
  submitSignup: func.isRequired,
  tab: oneOf(['login', 'signup', 'confirm']),

  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  onResendVerificationEmail: func.isRequired,
  onManageDisableScrolling: func.isRequired,

  // from withRouter
  location: shape({ state: object }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated, loginError, signupError, confirmError, content } = state.Auth;
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
  const { userShowError } = state.ProfilePage;
  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    scrollingDisabled: isScrollingDisabled(state),
    signupError,
    confirmError,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    userShowError,
    content,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
  submitSignup: params => dispatch(signup(params)),
  submitSingupWithIdp: params => dispatch(signupWithIdp(params)),
  onShowUser: userId => dispatch(showUser(userId)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onGetContent: role => dispatch(getContent(role)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AuthenticationPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(AuthenticationPageComponent);

export default AuthenticationPage;
